import { createContext, type ReactNode, useContext, useRef } from "react"
import { useStore } from "zustand"

import {
  createDateRangeStore,
  type DateRangeStore,
  initDateRangeStore,
} from "~/stores/dateRangeStore"

type DateRangeStoreApi = ReturnType<typeof createDateRangeStore>

const DateRangeStoreContext = createContext<DateRangeStoreApi | undefined>(undefined)

export interface DateRangeStoreProviderProps {
  children: ReactNode
}

export const DateRangeStoreProvider = ({ children }: DateRangeStoreProviderProps) => {
  const storeRef = useRef<DateRangeStoreApi>(undefined)
  if (!storeRef.current) {
    storeRef.current = createDateRangeStore(initDateRangeStore())
  }

  return (
    <DateRangeStoreContext.Provider value={storeRef.current}>
      {children}
    </DateRangeStoreContext.Provider>
  )
}

export const useDateRangeStore = <T,>(selector: (store: DateRangeStore) => T): T => {
  const dateRangeStoreContext = useContext(DateRangeStoreContext)

  if (!dateRangeStoreContext) {
    throw new Error(`useDateRangeStore must be used within DateRangeStoreProvider`)
  }

  return useStore(dateRangeStoreContext, selector)
}
